module.exports = __webpack_public_path__ + "static/img/service_passprime_icon_1.a3bf4c47.svg";